import React from "react";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Button } from "@/components/ui/button";
import { Plus, Trash2 } from "lucide-react";

export function Field({ label, v, on, type = "text", disabled, testId }) {
  return (
    <div>
      <Label>{label}</Label>
      <Input type={type} value={v || ""} onChange={(e) => on(e.target.value)} disabled={disabled} data-testid={testId} />
    </div>
  );
}

export function Repeater({ title, items, setItems, template, columns, canEdit, keyName }) {
  const add = () => setItems([...items, template()]);
  const rm = (id) => setItems(items.filter((i) => i.id !== id));
  const upd = (id, k, v) => setItems(items.map((i) => (i.id === id ? { ...i, [k]: v } : i)));
  return (
    <section>
      <div className="mb-3 flex items-center justify-between">
        <h3 className="font-dashboard text-base font-bold">{title}</h3>
        {canEdit && <Button size="sm" variant="outline" onClick={add} data-testid={`add-${keyName}-btn`}><Plus className="mr-1 h-3 w-3" /> Add</Button>}
      </div>
      {items.length === 0 && <p className="text-sm text-muted-foreground">None on record.</p>}
      <div className="space-y-3">
        {items.map((i) => (
          <div key={i.id}
            className="grid gap-3 rounded-md border border-border p-4"
            style={{ gridTemplateColumns: `repeat(${columns.length + (canEdit ? 1 : 0)}, minmax(0, 1fr))` }}
          >
            {columns.map(([k, lbl, type]) => (
              <Field
                key={k}
                label={lbl}
                type={type}
                v={type === "date" ? i[k]?.slice(0, 10) : i[k]}
                on={(v) => upd(i.id, k, type === "number" ? Number(v) : v)}
                disabled={!canEdit}
              />
            ))}
            {canEdit && (
              <div className="flex items-end">
                <Button size="sm" variant="ghost" onClick={() => rm(i.id)} data-testid={`rm-${keyName}-${i.id}`}><Trash2 className="h-4 w-4" /></Button>
              </div>
            )}
          </div>
        ))}
      </div>
    </section>
  );
}
